import { APIClient } from '../api_helper';
import { api } from '../../config';
import * as url from '../message/url_helper';

import qs from 'qs';

const apiClient = new APIClient(api.REACT_APP_SPED_MESSAGE_API_URL);

export const stringifyParams = params =>
	qs.stringify(params, {
		encodeValuesOnly: true,
	});

// messages 
export const sendNewEmailMessage = message => apiClient.post(url.ADD_MESSAGE, message, {
	headers: { 'Content-Type': 'application/x-www-form-urlencoded', },
});

// Notification
export const getNotificationList = params => { return apiClient.get(`${url.GET_NOTIFICATION}?${stringifyParams(params)}`); };
export const getNotification = notification => apiClient.get(url.NOTIFICATION + '/' + encodeURIComponent(notification));
export const addNewNotification = notification => apiClient.post(url.ADD_NOTIFICATION, notification);
export const addNewBulkNotification = notification => apiClient.post(url.ADD_BULK_NOTIFICATION, notification);
export const updateNotification = notification => apiClient.put(url.UPDATE_NOTIFICATION + '/' + notification._id, notification);
export const deleteNotification = notification => apiClient.delete(url.DELETE_NOTIFICATION + '/' + notification._id);
export const readNotification = notification => apiClient.put(url.READ_NOTIFICATION + '/' + notification);
export const readBulkNotification = notification => apiClient.put(url.READ_BULK_NOTIFICATION, notification);


// Notification Type
export const getNotificationTypeList = () => apiClient.get(url.GET_NOTIFICATION_TYPE);
export const getNotificationType = notification_type => apiClient.get(url.NOTIFICATION_TYPE + '/' + encodeURIComponent(notification_type));
export const addNewNotificationType = notification_type => apiClient.post(url.ADD_NOTIFICATION_TYPE, notification_type);
export const updateNotificationType = notification_type => apiClient.put(url.UPDATE_NOTIFICATION_TYPE + '/' + notification_type._id, notification_type);
export const deleteNotificationType = notification_type => apiClient.delete(url.DELETE_NOTIFICATION_TYPE + '/' + notification_type._id);


// Notification Priority
export const getNotificationPriorityList = () => apiClient.get(url.GET_NOTIFICATION_PRIORITY);
export const getNotificationPriority = notification_priority => apiClient.get(url.NOTIFICATION_PRIORITY + '/' + encodeURIComponent(notification_priority));
export const addNewNotificationPriority = notification_priority => apiClient.post(url.ADD_NOTIFICATION_PRIORITY, notification_priority);
export const updateNotificationPriority = notification_priority => apiClient.put(url.UPDATE_NOTIFICATION_PRIORITY + '/' + notification_priority._id, notification_priority);
export const deleteNotificationPriority = notification_priority => apiClient.delete(url.DELETE_NOTIFICATION_PRIORITY + '/' + notification_priority._id);
